import { html } from 'lit';
import { property, queryAssignedElements } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { AttributeValueValidator } from '../../lib/attribute-value-validator/attribute-value-validator.js';
import { trustedCSS } from '../../lib/css/css.js';
import { LightDomSlotFallbackController } from '../../lib/light-dom-slot-fallback/light-dom-slot-fallback-controller.js';
import { CrntIcon } from '../icon/icon.component.js';
import BoxedInputStyles from './boxed-input.css.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
const processingLightDomSlotFallbackControllerSlot = () => ({
  fallbackElement: () => {
    const icon = document.createElement("crnt-icon");
    icon.icon = "spinner-third";
    icon.animation = "spin";
    return icon;
  },
  slotName: "processing"
});
const CrntBoxedInputMixin = (superClass) => {
  class CrntBoxedInput extends superClass {
    constructor() {
      super(...arguments);
      this.interactionState = "default";
      this.state = "enabled";
      this._lightDomSlotFallbackController = new LightDomSlotFallbackController(this, [
        processingLightDomSlotFallbackControllerSlot
      ]);
      this._controlPlaceholderValidator = new AttributeValueValidator({
        attributeKey: "placeholder",
        host: this,
        validationWarningMessage: "Using placeholders are considered a bad practice in regards to user experience. CRNT does not support placeholders on input elements and will actively hide placeholders. Use a proper form-control-label and/or form-control-help-text-text to correctly inform the user.",
        validationWarningTitle: "Avoid using placeholders on inputs!",
        validValues: void 0
      });
    }
    static {
      this.dependencies = {
        "crnt-icon": CrntIcon
      };
    }
    static {
      this.styles = trustedCSS(BoxedInputStyles);
    }
    get _inputClasses() {
      return classMap({
        [`crnt-boxed-input--${this.interactionState}`]: this.interactionState,
        [`crnt-boxed-input--${this.state}`]: this.state,
        "crnt-boxed-input": true
      });
    }
    render() {
      return html`
				<div class=${this._inputClasses} part="container" @click=${this.handleContainerClick}>
					<slot class="crnt-boxed-input__leading" name="leading" part="leading"></slot>
					<slot part="control"></slot>
					<slot class="crnt-boxed-input__processing" name="processing" part="processing"></slot>
					<slot class="crnt-boxed-input__trailing" name="trailing" part="trailing"></slot>
				</div>
			`;
    }
    firstUpdated(_changedProperties) {
      super.firstUpdated(_changedProperties);
      this._lightDomSlotFallbackController.setFallbackSlotsContent();
      this._controls?.forEach((input) => {
        this._controlPlaceholderValidator.validate(input.getAttribute("placeholder"));
      });
    }
    handleContainerClick(event) {
      const control = this._controls?.[0];
      const { target } = event;
      if (control && (!target || !this._controls?.[0]?.isEqualNode(target))) {
        control.focus();
        control.showPicker();
      }
    }
  }
  __decorateClass([
    property({ attribute: "interaction-state" })
  ], CrntBoxedInput.prototype, "interactionState");
  __decorateClass([
    property({ reflect: true })
  ], CrntBoxedInput.prototype, "state");
  __decorateClass([
    queryAssignedElements({ selector: "input, select" })
  ], CrntBoxedInput.prototype, "_controls");
  return CrntBoxedInput;
};

export { CrntBoxedInputMixin, processingLightDomSlotFallbackControllerSlot };
